/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const AccountingPeriodService = {
  /**
   * Get current active accounting periods
   */
  async getCurrentActivePeriods() {
    const requestData = {
      url: "api/CurrentActiveAccountingPeriod",
    };
    return await ApiService.oDataGet(requestData);
  },

  /**
   * End of Period (Lock)
   * @param {string} periodType - e.g. "GL", "AR", "AP", "STK"
   */
  async endOfPeriod(periodType) {
    return await ApiService.post("api/AccountingPeriod/EndOfPeriod", {
      PeriodType: periodType,
    });
  },
};

export { AccountingPeriodService };
